<template>
	<v-dialog v-model="showDialog" scrollable width="600px">
		<v-card>
			<v-card-title> Manage Groups </v-card-title>

			<v-card-text></v-card-text>

			<v-divider />

			<v-card-actions>
				<v-btn text outlined @click="showDialog = false"> Close </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'ManageGroupsDialog',
	props: {
		dialog: Boolean,
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog;
			},
			set() {
				this.$emit('closeDialog');
			},
		},
	},
};
</script>

<style scoped></style>
